"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReplayReportList = exports.useWatchHistoryList = exports.useReplayList = exports.deleteReplay = exports.postReplayViewerExcel = exports.REPLAY_VIEWER_EXCEL_FORM_URL = exports.postModifyReplay = exports.postRegistReplay = void 0;
const account_1 = require("../../features/base/account");
const classes_1 = require("../../features/base/classes");
const functions_1 = require("../functions");
const getToken = () => (0, account_1.getAccessToken)(APP.store.getState);
// (다시보기) 다시보기 리스트 조회
const getReplay = async (queryString) => {
    const class_id = (0, classes_1.getClassesId)();
    const url = class_id
        ? `/api/mimac/v1/replays?${queryString}&class_id=${class_id}`
        : `/api/mimac/v1/replays?${queryString}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
// (다시보기) 시청 기록 조회
const getWatchHistory = async (id, queryString) => {
    const class_id = (0, classes_1.getClassesId)();
    const url = `/api/mimac/v1/replays/${id}/play-histories?${queryString}&class_id=${class_id}`; // API 엔드포인트 생성
    // return fetchData(url);
    return (0, functions_1.fetchData)(url, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
// (다시보기) 시청 기록 조회
const getReplayReport = async (id, queryString) => {
    const class_id = (0, classes_1.getClassesId)();
    const url = `/api/mimac/v1/members/${id}/replay-report?${queryString}&class_id=${class_id}`; // API 엔드포인트 생성
    // return fetchData(url);
    return (0, functions_1.fetchData)(url, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
// (다시보기) 다시보기 등록
const postRegistReplay = async (data) => {
    const url = `/api/mimac/v1/replays`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data),
    });
};
exports.postRegistReplay = postRegistReplay;
// (다시보기) 다시보기 수정
const postModifyReplay = async (props) => {
    const url = `/api/mimac/v1/replays/${props.id}/update`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(props.data),
    });
};
exports.postModifyReplay = postModifyReplay;
// 다시보기 일부 공개 참여자 엑셀 양식 다운로드(인증 불필요 — SMS 양식과 같이 주소 이동으로 받는다)
exports.REPLAY_VIEWER_EXCEL_FORM_URL = '/api/mimac/v1/replays/download-excel-form';
// 다시보기 일부 공개 참여자 엑셀 업로드 — 파일의 아이디를 클래스 멤버와 매칭해 돌려준다(저장하지 않음).
// 서버: 빈 값·파일 내 중복은 무시, 매칭 안 된 아이디는 skip 으로 집계. 이미 추가된 참여자와의 중복 제거는 화면 몫.
const postReplayViewerExcel = async (file) => {
    const formData = new FormData();
    formData.append('class_id', (0, classes_1.getClassesId)());
    formData.append('file', file);
    return (0, functions_1.fetchData)(`/api/mimac/v1/replays/upload-excel`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${getToken()}`,
        },
        body: formData,
    });
};
exports.postReplayViewerExcel = postReplayViewerExcel;
// 다시보기 삭제
const deleteReplay = async (id) => {
    const url = `/api/mimac/v1/replays/${id}/delete`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
exports.deleteReplay = deleteReplay;
// 강의 다시보기 리스트 조회
const useReplayList = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data);
    return (0, functions_1.useCustomQuery)([`replay_${data}`, data], () => getReplay(queryString));
};
exports.useReplayList = useReplayList;
// 시청 이력보기 리스트 조회
const useWatchHistoryList = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data);
    return (0, functions_1.useCustomQuery)([`watch_history_${data}`, data], () => getWatchHistory(data.id, queryString));
};
exports.useWatchHistoryList = useWatchHistoryList;
// e다시 보기 시청 현황 조회
const useReplayReportList = (data) => {
    const { id, ...rest } = data || {};
    const queryString = (0, functions_1.objectToQueryString)(rest);
    return (0, functions_1.useCustomQuery)([`replay_${id}`], () => getReplayReport(id, queryString));
};
exports.useReplayReportList = useReplayReportList;
